import api from './api'

/**
 * Serviço de Autenticação
 */
export default {
  /**
   * Realizar login no backend
   * @param {string} idToken - Token do Firebase
   * @param {string} tenantId - ID do tenant
   */
  login(idToken, tenantId) {
    return api.post('/api/auth/login', null, {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'X-Tenant-Id': tenantId,
      },
    })
  },

  /**
   * Validar token atual
   */
  validateToken() {
    return api.get('/api/auth/validate')
  },
}
